import { exclusionAreas } from '../farmMapping/exclusionAreas/index'
import { monitoringSites } from '../farmMapping/monitoringSites'
import { samplingAreas } from '../farmMapping/samplingAreas/index'
import { paddocks } from '../farmMapping/savePaddocks'
import { getRawDataCollection } from './getRawDataCollection'
import { metricsProviderService } from './metricsProvider'
import saveMetrics, { saveVerificationMetric } from './saveMetrics'
import { reports } from './reports'
import randomizeV4Generate from './randomizeV4Generate'
import getRandomizerTypeId from './getRandomizerTypeId'
import { v2 } from './v2/index'

export const ruutsApi = {
  v2,
  saveMetrics,
  saveVerificationMetric,
  paddocks,
  samplingAreas,
  monitoringSites,
  getRawDataCollection,
  metricsProviderService,
  exclusionAreas,
  reports,
  getRandomizerTypeId,
  randomizeV4Generate,
}
